import { createReducer } from "@reduxjs/toolkit";

import {
  getProposalUsers,
  getProposalUsersSuccess,
  getProposalUsersFailure,
  getMoreProposalUsers,
  getMoreProposalUsersSuccess,
  getMoreProposalUsersFailure,
  setProposalUsers,
  createProposal,
  createProposalSuccess,
  createProposalFailure,
  createProposalReset,
  addPendingProposal,
  removePendingProposal,
  editProposal,
  editProposalFailure,
  editProposalSuccess,
  editProposalReset,
  getProposalDetails,
  getProposalDetailsSuccess,
  getProposalDetailsFailure,
  clearIsJustCreated,
} from "./actions";

const initialState = {
  isLoading: false,
  allUsers: [],
  userById: {},
  totalCount: 0,
  nextOffset: 0,
  pendingProposals: {},
  isCreating: false,
  isCreated: false,
  isEditing: false,
  isEdited: false,
  isJustCreated: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getProposalUsers.type, (state) => {
      state.isLoading = true;
    })
    .addCase(getProposalUsersSuccess.type, (state, { payload }) => {
      const { allUsers, totalCount, nextOffset } = payload;

      state.isLoading = false;
      state.allUsers = allUsers;
      state.totalCount = totalCount;
      state.nextOffset = nextOffset;
    })
    .addCase(getProposalUsersFailure.type, (state) => {
      state.isLoading = false;
    })
    .addCase(setProposalUsers.type, (state, { payload }) => {
      state.userById = { ...state.userById, ...payload };
    })
    .addCase(getMoreProposalUsers.type, (state) => {
      state.isLoading = true;
    })
    .addCase(getMoreProposalUsersFailure.type, (state) => {
      state.isLoading = false;
    })
    .addCase(getMoreProposalUsersSuccess.type, (state, { payload }) => {
      const { allUsers: newAllUsers, user, totalCount, nextOffset } = payload;

      return {
        ...state,
        totalCount,
        nextOffset,
        isLoading: false,
        allUsers: [...state.allUsers, ...newAllUsers],
        userById: { ...state.userById, ...user },
      };
    })
    .addCase(createProposal.type, (state) => {
      state.isCreating = true;
    })
    .addCase(createProposalSuccess.type, (state) => {
      state.isCreating = false;
      state.isCreated = true;
      state.isJustCreated = true;
    })
    .addCase(createProposalFailure.type, (state) => {
      state.isCreating = false;
      state.isCreated = false;
    })
    .addCase(createProposalReset.type, (state) => {
      state.isCreated = false;
      state.isCreating = false;
    })
    .addCase(clearIsJustCreated.type, (state) => {
      state.isJustCreated = false;
    })
    .addCase(addPendingProposal.type, (state, { payload }) => {
      const { pendingProposals } = state;

      const newPendingProposals = { ...pendingProposals };

      payload.forEach(
        (id) => (newPendingProposals[id] = (newPendingProposals[id] ?? 0) + 1),
      );

      return {
        ...state,
        pendingProposals: newPendingProposals,
      };
    })
    .addCase(removePendingProposal.type, (state, { payload }) => {
      const { pendingProposals } = state;

      const newPendingProposals = { ...pendingProposals };

      payload.forEach(
        (id) => (newPendingProposals[id] = (newPendingProposals[id] ?? 0) - 1),
      );

      return {
        ...state,
        pendingProposals: newPendingProposals,
      };
    })
    .addCase(editProposal, (state) => {
      state.isEditing = true;
    })
    .addCase(editProposalSuccess, (state) => {
      state.isEditing = false;
      state.isEdited = true;
    })
    .addCase(editProposalFailure, (state) => {
      state.isEditing = false;
      state.isEdited = false;
    })
    .addCase(editProposalReset, (state) => {
      state.isEditing = initialState.isEditing;
      state.isEdited = initialState.isEdited;
    })
    .addCase(getProposalDetails, (state) => {
      state.isLoading = true;
    })
    .addCase(getProposalDetailsSuccess, (state) => {
      state.isLoading = false;
    })
    .addCase(getProposalDetailsFailure, (state) => {
      state.isLoading = false;
    });
});
